import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {permissions, sdoNs} from '../constants-enumerate';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import '@modules/inventory-updates-log/inventory-updates-log-sdo';
import '../sdo-user-jobs';
import SessionActions from '../session-sdo';
import './left-menu-sdo';
import {ApiService} from '@modules/api-service';
import {hasOneOfPermissions} from '@modules/permissions';

/**
 * @summary LeftMenu
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('left-menu')
class LeftMenu extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of LeftMenu.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }
  /**
   * @readonly
   * @type {String}
   */
  static is = 'left-menu';

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.$myGroups`, store: storeInstance})
  myGroups = {};

  @property({type: Number, attribute: false, mapState: `${sdoNs.SESSION}.$classLevel`, store: storeInstance})
  classLevel = 0;

  @property({type: Number, attribute: false, mapState: `${sdoNs.SESSION}.$showLanding`, store: storeInstance})
  showLanding = false;

  @property({type: Array, attribute: false, mapState: `${sdoNs.LEFT_MENU}.$menuItems`, store: storeInstance})
  menuItems = [];

  @property({type: Array, attribute: false, mapState: `${sdoNs.SESSION}.group_info.level`, store: storeInstance})
  myLevel = '0';

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.group_info.name`, store: storeInstance})
  groupName = '';

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.type`, store: storeInstance})
  userType = '';

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.name`, store: storeInstance})
  username = '';

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.PARENT_DASHBOARD}.$showDashboardLink`, store: storeInstance})
  showDashboardLinkForParent = false;

  @property({
    type: Number,
    mapState: `${sdoNs.SESSION}.group_info.id`,
    store: storeInstance,
    hasChanged: async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        if (newVal) {
          const queryObj = {
            filters: {
              group_id: newVal
            },
            sort: {
              limit: 2,
              is_forward: true,
              fields: ['timestamp', 'id'],
            },
          };
          if (!hasOneOfPermissions([permissions.SPONSOR, permissions.HIDE_STUDENT])) {
            const resp = await ApiService.inventoryUpdatesLogSearch(queryObj);
            storeInstance.commit({
              namespace: sdoNs.INVENTORY_UPDATE_LOG,
              mutationId: 'setData',
              payload: resp
            });
          }
        }
        return true;
      }
      return false;
    },
  })
  groupId = null;

  @property({type: Object, mapState: `${sdoNs.INVENTORY_UPDATE_LOG}.sort`, store: storeInstance})
  inventoryUpdateLogSort = {};

  logout() {
    setTimeout(() => {
      SessionActions.logout();
    }, 150); /** @todo temporary hack - wait for drawer to close */
  }

  onFocusTrap(event) {
    if (event.target.id === 'focus-pre') {
      this.querySelector('[focuslast]')
        ?.focus();
    } else if (event.target.id === 'focus-post') {
      this.querySelector('[focusfirst]')
        ?.focus();
    }
  }
  connectedCallback() {
    super.connectedCallback();
    const state = this.storeInstance.getState();
    this.hasMultipleProfiles = state[sdoNs.SESSION].profiles.length > 1;
    const focusTrap = state[sdoNs.SIDE_PANELS].$overlay;
    const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
    const smallWindow = mobileMediaQuery.matches;
    if (focusTrap && smallWindow) {
      this.shadowRoot.addEventListener('focus', this.onFocusTrap, true);
    } else {
      this.shadowRoot.removeEventListener('focus', this.onFocusTrap, true);
    }
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default LeftMenu;
